export default __webpack_public_path__ + "static/media/Dr._Kyla_L._Tennin_AHV_In_Moms_We_Trust.516edff9.jpg";